import React from 'react';
import properties from '../../constants/Properties';
import modeType from '../../constants/ModeConstants';
import { lockShape, bringToFront, sendToBack, bringForward, sendBackward, updateCurrentSlideThumbnail } from '../../actions/CurrentSlideActions';
import storeManager from '../../store/StoreManager';
import { EffectsMenu } from './EffectsMenu';
import { CustomSlider } from './CustomSlider';
import { changeContextMode, expandEffectsList } from '../../actions/MenuActions';
import locales from '../../locales/LocalesManager';
import appParameters from '../../components/utils/AppParameters';
import mouseUtils from '../../components/utils/MouseUtils';
import saveManager from '../utils/SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import platformDetection from '../utils/PlatformDetection';

const Title = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;

        dispatch(changeContextMode(modeType.CONTEXT_NONE));
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        const titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: 0
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            position: 'absolute',
            top: 6,
            width: this.props.accordionWidth - 3 * properties.BROWSER_LEFT_PADDING,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        const closeButtonStyle = {
            position: 'absolute',
            width: 21,
            height: 21,
            top: 4,
            right: 27,
            cursor: 'pointer',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            background: 'none',
            borderStyle: 'none'
        };

        const closeStyle = {
            position: 'absolute',
            width: 15,
            top: 3,
            left: 3
        };

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{locales.getCaption('AdvancedMenuTitle', 'advancedMenu')}</span>
                <button id="firstFocusableObjectFromMoreMenu" aria-label={locales.getCaption('close', 'other')} style={closeButtonStyle} onClick={this.onClick} onTouchEnd={this.onClick}>
                    <img alt='' aria-hidden='true' style={closeStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/exit_edit.png'}/>
                </button>
            </div>
        );
    }
});

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    updateThumbnail() {
        setTimeout(this.updateThumb, 10);
    },
    updateThumb() {
        this.props.dispatch(updateCurrentSlideThumbnail(true));
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        switch (this.props.index) {
            case 0: {
                // lock button
                this.props.dispatch(lockShape(this.props.contextTarget));
                this.forceUpdate();
                this.updateThumbnail();
                saveManager.isContentChanged(true);
                break;
            }

            case 1: {
                // bring to front
                if (this.isCommandAvailable(1)) {
                    this.props.dispatch(bringToFront(this.props.contextTarget));
                    this.updateThumbnail();
                    saveManager.isContentChanged(true);
                }
                break;
            }

            case 2: {
                // send to back
                if (this.isCommandAvailable(2)) {
                    this.props.dispatch(sendToBack(this.props.contextTarget));
                    this.updateThumbnail();
                    saveManager.isContentChanged(true);
                }
                break;
            }

            case 3: {
                // bring forward
                if (this.isCommandAvailable(3)) {
                    this.props.dispatch(bringForward(this.props.contextTarget));
                    this.updateThumbnail();
                    saveManager.isContentChanged(true);
                }
                break;
            }

            case 4: {
                // send backward
                if (this.isCommandAvailable(4)) {
                    this.props.dispatch(sendBackward(this.props.contextTarget));
                    this.updateThumbnail();
                    saveManager.isContentChanged(true);
                }
                break;
            }
        }

        audioEditorUtils.addActionToHistory();
    },
    isCommandAvailable (index) {
        const state = storeManager.getState();
        const uuid = this.props.contextTarget.uuid;
        const shapes = state.currentSlide.model.content;
        var i;
        var targetPosition;

        for (i=0; i<shapes.length; i++) {
            if (shapes[i].uuid == uuid) {
                targetPosition = i;
                break;
            }
        }

        switch (index) {
            case 1: // bring to front
            case 3: // bring forward
            {
                if (targetPosition < (shapes.length - 1))
                    return true;
                break;
            }

            case 2: // send to back
            case 4: // send backward
            {
                if (targetPosition > 1)
                    return true;
                break;
            }
        }

        return false;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.contextTarget != newProps.contextTarget || this.props.isLocked != newProps.isLocked)
            return true;
        else
            return false;
    },
    render() {
        var iconColor;
        var buttonColor;

        if (this.state.isOver == true) {
            iconColor = properties.CONTEXT_HOVER_COLOR;
            buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
        } else {
            iconColor = 'black';
            buttonColor = properties.SLIDE_MENU_COLOR;
        }

        var topPosition = this.props.index * properties.OBJECT_ADVANCED_BUTTON_HEIGHT;

        if (this.props.index == 7) {
            topPosition = 6 * properties.OBJECT_ADVANCED_BUTTON_HEIGHT + properties.OBJECT_ADVANCED_MIDDLE_GAP;
            iconColor = 'black';
            buttonColor = properties.SLIDE_MENU_COLOR;
        }

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: this.props.accordionWidth - properties.BROWSER_LEFT_PADDING,
            height: properties.OBJECT_ADVANCED_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: properties.BROWSER_LEFT_PADDING,
            top: topPosition,
            color: 'white',
            margin: 0,
            paddingRight: 0,
            paddingTop: 0,
            paddingBottom: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none'
        };

        const spanStyle = {
            color: iconColor,
            cursor: 'default',
            fontSize: 16,
            paddingLeft: 22,
            top: 0
        };

        const iconStyle = {
            position: 'absolute',
            top: 16,
            color: iconColor
        };

        var icon = this.props.icon;
        var text = this.props.text;

        if (this.props.index == 0 && this.props.isLocked == true) {
            text = locales.getCaption('UnlockObject', 'advancedMenu');
            icon = 'fa fa-unlock';
        }

        var tabIndexValue;

        if (this.props.isLocked && this.props.index != 0)
            tabIndexValue = '-1';

        return (
            <button aria-label={text} tabIndex={tabIndexValue} aria-disabled={tabIndexValue == '-1' ? true : false} style={buttonStyle} onTouchEnd={this.onClick} onClick={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <i style={iconStyle} className={icon}></i>
                <span style={spanStyle}>{text}</span>
            </button>
        );
    }
});

const InactiveArea = React.createClass({
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.accordionWidth != newProps.accordionWidth || this.props.windowHeight != newProps.windowHeight)
            return true;
        else
            return false;
    },
    render() {
        var top = properties.OBJECT_ADVANCED_BUTTON_HEIGHT;

        const inactiveAreaStyle = {
            position: 'absolute',
            top: top,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight - top,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white',
            opacity: 0.5
        };

        return (
            <div style={inactiveAreaStyle}/>
        );
    }
});

export const ObjectContextAdvanced = React.createClass({
    componentDidMount() {
        this.refs.contextAdvancedWrapper.addEventListener('click', this.onClick);
        this.refs.contextAdvancedWrapper.addEventListener('touchend', this.onClick);

        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            var element = document.getElementById('firstFocusableObjectFromMoreMenu');

            if (element)
                element.focus();
        }.bind(this), 30);
    },
    isLocked () {
        const state = storeManager.getState();
        const uuid = this.props.contextTarget.uuid;
        const shapes = state.currentSlide.model.content;
        var i;

        for (i=0; i<shapes.length; i++) {
            if (shapes[i].uuid == uuid)
                return shapes[i].isLocked;
        }

        return false;
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const target = e.target;
        if (target.id != 'effectsMenu' && target.parentNode.id != 'effectsMenu' && target.parentNode.parentNode.id != 'effectsMenu' && target.parentNode.parentNode.parentNode.id != 'effectsMenu')
            this.props.dispatch(expandEffectsList(false));

        setTimeout(this.refreshView, 5);
    },
    refreshView() {
        this.forceUpdate();
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight || this.props.contextTarget != newProps.contextTarget || this.props.contextMode != newProps.contextMode || this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        if (this.props.contextMode != modeType.OBJECT_CONTEXT_ADVANCED)
            return <div/>;

        const menuStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white',
            cursor: 'default'
        };

        var topPosition = 5 * properties.OBJECT_ADVANCED_BUTTON_HEIGHT + properties.OBJECT_ADVANCED_MIDDLE_GAP / 2;

        const topLineStyle = {
            position: 'absolute',
            backgroundColor: '#E1E1E1',
            height: 1,
            width: properties.BROWSER_WIDTH - 2 * properties.BROWSER_LEFT_PADDING,
            marginLeft: properties.BROWSER_LEFT_PADDING,
            top: topPosition
        };

        var isLocked = this.isLocked();
        var elements = [];

        topPosition = topPosition + properties.OBJECT_ADVANCED_MIDDLE_GAP;

        const spanOpacityStyle = {
            position: 'absolute',
            left: properties.BROWSER_LEFT_PADDING,
            top: topPosition,
            cursor: 'default'
        };

        topPosition = topPosition + properties.OBJECT_ADVANCED_MIDDLE_GAP + 5;

        var opacityProperties = {};
        opacityProperties.topPosition = topPosition;
        opacityProperties.leftPosition = properties.BROWSER_LEFT_PADDING;
        opacityProperties.width = properties.BROWSER_WIDTH - 2 * properties.BROWSER_LEFT_PADDING;
        opacityProperties.height = properties.STYLING_SLIDER_HEIGHT;
        opacityProperties.backgroundHref = appParameters.RESOURCES_LOCATION() + 'assets/opacitySlider.png';
        opacityProperties.thumbHref = appParameters.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
        opacityProperties.thumbSize = properties.STYLING_THUMB_SIZE;
        opacityProperties.start = 1;
        opacityProperties.end = 0;
        opacityProperties.step = 0.1;
        opacityProperties.target = this.props.contextTarget;
        opacityProperties.dispatch = this.props.dispatch;
        opacityProperties.type = 'change_opacity';

        topPosition = topPosition + properties.STYLING_SLIDER_HEIGHT + properties.OBJECT_ADVANCED_MIDDLE_GAP;

        const bottomLineStyle = {
            position: 'absolute',
            backgroundColor: '#E1E1E1',
            height: 1,
            width: properties.BROWSER_WIDTH - 2 * properties.BROWSER_LEFT_PADDING,
            marginLeft: properties.BROWSER_LEFT_PADDING,
            top: topPosition
        };

        topPosition = topPosition + properties.OBJECT_ADVANCED_MIDDLE_GAP;

        elements.push(<Button accordionWidth={properties.BROWSER_WIDTH} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} isLocked={isLocked} index={0} icon='fa fa-lock' text={locales.getCaption('LockObject', 'advancedMenu')} key={'context0'}/>);
        elements.push(<Button accordionWidth={properties.BROWSER_WIDTH} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} isLocked={isLocked} index={1} icon='fa fa-arrow-circle-up' text={locales.getCaption('BringToFront', 'advancedMenu')} key={'context1'}/>);
        elements.push(<Button accordionWidth={properties.BROWSER_WIDTH} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} isLocked={isLocked} index={2} icon='fa fa-arrow-circle-down' text={locales.getCaption('SendToBack', 'advancedMenu')} key={'context2'}/>);
        elements.push(<Button accordionWidth={properties.BROWSER_WIDTH} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} isLocked={isLocked} index={3} icon='fa fa-arrow-circle-o-up' text={locales.getCaption('BringForward', 'advancedMenu')} key={'context3'}/>);
        elements.push(<Button accordionWidth={properties.BROWSER_WIDTH} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} isLocked={isLocked} index={4} icon='fa fa-arrow-circle-o-down' text={locales.getCaption('SendBackward', 'advancedMenu')} key={'context4'}/>);
        elements.push(<div style={topLineStyle} key={'context5'}/>);
        elements.push(<span key={'context6'} style={spanOpacityStyle}>{locales.getCaption('Opacity', 'advancedMenu')}</span>);
        elements.push(<CustomSlider key={'context7'} properties={opacityProperties}/>);
        elements.push(<div key={'context8'} style={bottomLineStyle}/>);
        elements.push(<EffectsMenu id="objectContextLastFocusableElement" accordionWidth={properties.BROWSER_WIDTH} key={'context9'} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} top={topPosition}/>);

        if (isLocked == true)
            elements.push(<InactiveArea accordionWidth={this.props.accordionWidth} windowHeight={this.props.windowHeight - properties.CLIPART_BUTTON_HEIGHT} key={'context11'}/>);

        const height = topPosition + 50;

        var leftPosition = 0;

        if (this.props.accordionWidth > properties.BROWSER_WIDTH)
            leftPosition = (this.props.accordionWidth - properties.BROWSER_WIDTH) / 2;

        const holderStyle = {
            position: 'absolute',
            top: properties.CLIPART_BUTTON_HEIGHT,
            left: leftPosition,
            height: this.props.windowHeight - properties.CLIPART_BUTTON_HEIGHT,
            width: this.props.accordionWidth,
            overflowY: 'auto',
            overflowX: 'hidden',
            cursor: 'default'
        };

        const elementsWrapperStyle = {
            position: 'absolute',
            top: 0,
            height: height,
            width: properties.BROWSER_WIDTH,
            cursor: 'default'
        };

        return (
            <div ref='contextAdvancedWrapper' style={menuStyle} id="objectContextMenu">
                <Title accordionWidth={this.props.accordionWidth}/>
                <div style={holderStyle}>
                    <div style={elementsWrapperStyle}>
                        {elements}
                    </div>
                </div>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/ObjectContextAdvanced.js
 **/